<!--
  Site footer. Links and credits sit on --ui-ground with a hairline above; the
  brand-configured FooterColor is gone so the band follows the theme preset
  like every other redesigned surface.
-->
<footer class="ui-ground site-footer">
  <div class="site-footer__inner">
    <nav class="site-footer__links" aria-label="Footer">
      <ng-container *ngIf="Footer?.TermsConditions?.Enabled">
        <a
          *ngIf="Footer?.TermsConditions?.URL"
          [href]="Footer?.TermsConditions?.URL"
          target="_blank"
          rel="noopener"
          class="site-footer__link"
          >{{ Footer?.TermsConditions?.Text }}</a
        >
        <a
          *ngIf="!Footer?.TermsConditions?.URL"
          href="javascript:void(0)"
          (click)="openUrl('terms-and-conditions')"
          class="site-footer__link"
          >{{ Footer?.TermsConditions?.Text }}</a
        >
      </ng-container>

      <ng-container *ngIf="Footer?.PrivacyPolicy?.Enabled">
        <a
          *ngIf="Footer?.PrivacyPolicy?.URL"
          [href]="Footer?.PrivacyPolicy?.URL"
          target="_blank"
          rel="noopener"
          class="site-footer__link"
          >{{ Footer?.PrivacyPolicy?.Text }}</a
        >
        <a
          *ngIf="!Footer?.PrivacyPolicy?.URL"
          href="javascript:void(0)"
          (click)="openUrl('privacy-policy')"
          class="site-footer__link"
          >{{ Footer?.PrivacyPolicy?.Text }}</a
        >
      </ng-container>

      <a
        *ngIf="Footer?.Unsubscribe?.Enabled"
        href="javascript:void(0)"
        (click)="unsubscribeModel = true; UnsubResult = ''"
        class="site-footer__link"
        >{{ Footer?.Unsubscribe?.Text }}</a
      >
    </nav>

    <p class="site-footer__legal">
      <span>Copyright &copy; {{ currentDateStr }}. All Rights Reserved</span>

      <span class="site-footer__credit" *ngIf="Footer?.Partners?.Enabled">
        <img
          class="site-footer__mark"
          width="26"
          height="26"
          *ngIf="configLoaded && Footer?.Partners?.ImageURL"
          [src]="Footer.Partners.ImageURL"
          alt=""
          loading="lazy"
          decoding="async"
        />
        <a
          *ngIf="Footer?.Partners?.URL"
          [href]="Footer?.Partners?.URL"
          target="_blank"
          rel="noopener"
          class="site-footer__link"
          >{{ Footer?.Partners?.Text }}</a
        >
        <span *ngIf="!Footer?.Partners?.URL">{{ Footer?.Partners?.Text }}</span>
      </span>

      <span class="site-footer__credit" *ngIf="Footer?.Brand?.Enabled">
        <img
          class="site-footer__mark"
          width="26"
          height="26"
          *ngIf="configLoaded && Footer?.Brand?.ImageURL"
          [src]="Footer?.Brand?.ImageURL"
          alt=""
          loading="lazy"
          decoding="async"
        />
        <ng-container *ngIf="Footer?.Brand?.URL">
          {{ Footer?.Brand?.Prefix }}
          <a
            [href]="Footer?.Brand?.URL"
            target="_blank"
            rel="noopener"
            class="site-footer__link"
            >{{ Footer?.Brand?.Postfix }}</a
          >
        </ng-container>
        <ng-container *ngIf="!Footer?.Brand?.URL">{{
          Footer?.Brand?.Prefix
        }}</ng-container>
      </span>
    </p>
  </div>
</footer>

<div class="overlay unsub" *ngIf="unsubscribeModel">
  <div class="ui-card unsub__panel">
    <div class="unsub__head">
      <h2 class="unsub__title">Unsubscribe</h2>
      <button
        type="button"
        class="ui-btn ui-btn--ghost ui-btn--sm ui-btn--icon"
        aria-label="Close"
        (click)="unsubscribeModel = false"
      >
        &times;
      </button>
    </div>

    <div class="unsub__body">
      <p class="ui-hint ui-hint--muted unsub__intro">
        Please enter your details to unsubscribe from {{ BrandName }}
        promotional text.
      </p>

      <input
        type="text"
        name="unsubField"
        id="unsubField"
        placeholder="Enter your email/mobile number"
        class="ui-input"
        [(ngModel)]="UnsubField"
      />

      <p
        class="ui-alert"
        [class.ui-alert--success]="UnsubResult === 'Unsubscribed Successfully'"
        [class.ui-alert--danger]="UnsubResult !== 'Unsubscribed Successfully'"
        *ngIf="UnsubResult"
      >
        {{ UnsubResult }}
      </p>

      <button
        type="button"
        class="ui-btn ui-btn--block unsub__cta"
        (click)="unsubscribe()"
      >
        Unsubscribe
      </button>
    </div>
  </div>
</div>
